import Vue from 'vue'

type PossibleStatus = 'none' | 'copied' | 'error'

type CopyTextState = {
  copyTextStatus: PossibleStatus
}

/**
 * Copying text functionality has a lot of boilerplate, and having it encapsulated in a component
 * proved unflexible for styling. Therefore, the mixin. It provides:
 * @function copyText method
 * @function reset helper for maintaining the internal state
 * @getter successfullyCopiedText for easy feedback
 */

export default Vue.extend({
  data(): CopyTextState {
    return {
      copyTextStatus: 'none',
    }
  },
  methods: {
    copyText(value: string | number): void {
      // 1) if there was a selection on the page, save it
      let selected
      if (document.getSelection() && document.getSelection()!.rangeCount > 0) {
        selected = document.getSelection()!.getRangeAt(0)
      }

      // 2) create a textarea, fill it with value, append hidden, select value...
      const el = document.createElement('textarea')
      el.value = value.toString()
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()

      // 3) ...attempt to copy it, throw if fail
      try {
        document.execCommand('copy')
        this.setCopyTextStatus('copied')
        this.$emit('copy-text-success')
      } catch (err: any) {
        this.setCopyTextStatus('error')
        this.$emit('copy-text-error')
        throw new Error(err)
      }

      // 4) remove the textarea
      document.body.removeChild(el)

      // 5) restore the original selection, if any
      if (selected) {
        document.getSelection()!.removeAllRanges()
        document.getSelection()!.addRange(selected)
      }
    },
    setCopyTextStatus(status: PossibleStatus): void {
      this.copyTextStatus = status
    },
    resetCopyTextStatus(): void {
      this.copyTextStatus = 'none'
    },
  },
  computed: {
    successfullyCopiedText(): boolean {
      return this.copyTextStatus == 'copied'
    },
  },
})
